export const environment = {
  production: false,
  get apiUrl() {
    if (typeof window !== 'undefined') {
      const host = window.location.hostname;
      return host === 'localhost' || host === '127.0.0.1'
        ? 'https://sonar-stage.all.promo'
        : `https://${host}`;
    }
    return 'https://sonar-stage.all.promo';
  }
};
